// // src/Api/Api.js
// export const Api =
//   process.env.NODE_ENV === "production"
//     ? "https://muruganbag.infinityfree.me/murugan2/" // Change to your actual domain
//     : "http://localhost/murugan2/"; // If testing locally with XAMPP/LAMP

// src/Api/Api.js
export const Api =
  process.env.NODE_ENV === "production"
    ? "https://bags.srimurugangroups.com/murugan2/" // ✅ relative path for InfinityFree
    : "http://localhost/murugan2/"; // Local testing
